import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface GridColumn {
  gridListId: number;
  name: string;
  property: string;
  visible: string;
  disabled: string;
  cssClasses: string;
  gridId: number;
  isModelProperty: string;
}

export interface ListColumn {
  name: string;
  property: string;
  visible: boolean;
  isModelProperty: boolean;
  cssClasses?: string[];
  disabled?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class GridService {


  url = environment.serverAPI9 + '/api/grid';

  url1 = environment.serverAPI4 + "/api/eavattribute";

  constructor(private http: HttpClient) { }

  getAllGrid(Page: any, size: any, sort: any, types: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&types=${types}`);
  }

  getAllGridDetail(types: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?types=${types}`);
  }

  getAllGridDetailByType(type): Observable<Object> {
    return this.http.get(`${this.url}/dropdown/${type}`);
  }

  getGridById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  getGridByIdAndType(id: number, type: any): Observable<Object> {
    return this.http.get(`${this.url}/type/${id}/${type}`);
  }

  addOrEditGrid(gridcontainer: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, gridcontainer);
  }

  GridSearch(query, Page: any, size: any, sort: any, types: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&type=${types}`);
  }

  getDropDown(entityTypeId: number) {
    return this.http.get(`${this.url1}/grid/${entityTypeId}`);
  }

  transformGridColumns(gridColumnList: GridColumn[]): ListColumn[] {
    return gridColumnList.map(col => ({
      name: col.name,
      property: col.property.toLowerCase(),
      visible: col.visible === 'true',
      isModelProperty: col.isModelProperty === 'true',
      cssClasses: col.cssClasses ? col.cssClasses.split(' ') : [],
      disabled: col.disabled === 'true',
      displayFn: (value: any) => value
    }));
  }

  url2 = environment.serverAPI9 + '/api/gridTableConfig';

  saveGridConfig(config: any): Observable<any> {
    return this.http.post(`${this.url2}`, config);
  }

  getGridConfig(): Observable<any> {
    return this.http.get(`${this.url2}/user`);
  }

}
